import { AiFillStar } from "react-icons/ai";

const Ratings = () => {
  return (
    <div className="ratings">
      <AiFillStar className="review-icon" />
      <AiFillStar className="review-icon" />
      <AiFillStar className="review-icon" />
      <AiFillStar className="review-icon" />
      <AiFillStar className="review-icon" />
    </div>
  );
};

export default Ratings;
